import { de } from '../../i18n/i18n.de';
import { en } from '../../i18n/i18n.en';

const translations = {
  de: de,
  en: en,
};

//
// We have keys like 'foo.bar.fii' and objects like { foo: { bar: { fii: 'lala' }} }
//
const getDescendantProp = (obj: any, path: string) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

//
// The actual translation methid
//
export const t_stateless = (locale: string, key: string): string => {
  if (key === undefined || key === null || key === '') {
    return '???';
  }
  const translationsForLocale = (translations as any)[locale] as any;
  const trans = getDescendantProp(translationsForLocale, key);
  if (trans && trans.length > 0) {
    return trans;
  }
  return '???';
};

export const detectBrowserLanguage = () => {
  let found = [];
  if (typeof navigator !== 'undefined') {
    if (navigator.languages) {
      // chrome only; not an array, so can't use .push.apply instead of iterating
      for (let i = 0; i < navigator.languages.length; i++) {
        found.push(navigator.languages[i]);
      }
    }
    if ((navigator as any)['userLanguage']) {
      found.push((navigator as any)['userLanguage']);
    }
    if (navigator.language) {
      found.push(navigator.language);
    }
    return found.length > 0 ? sanitizeLocale(found[0]) : 'en';
  }
  return 'en';
};

export const sanitizeLocale = (lcl: string) => {
  if (lcl && lcl.startsWith('de')) {
    return 'de';
  }
  if (lcl && lcl.startsWith('en')) {
    return 'en';
  }
  // FALLBACK
  return 'en';
};
